export const temas = [
  { opcion: 'temaFocusArea2', nombre: 'Set de colores 1' },
  { opcion: 'theme-temaIzzi', nombre: 'Set de colores 2' },
  { opcion: 'theme-blue-gray-dark', nombre: 'Set de colores 3' },
  { opcion: 'theme-pink-dark', nombre: 'Set de colores 4' },
  { opcion: 'theme-temaIzzi-2', nombre: 'Set de colores 5' },
  { opcion: 'theme-temaItbm', nombre: 'Set de colores 6' },
  // { opcion: 'theme-prro', nombre: 'Set de colores 5' },
];

export const numColumnas = [
  { opcion: 1, nombre: '1 columna' },
  { opcion: 4, nombre: '4 columnas' },
  { opcion: 5, nombre: '5 columnas' },
];

export const segundos = [
  { opcion: 1000, nombre: '1 segundo' },
  { opcion: 2000, nombre: '2 segundos' },
  { opcion: 3000, nombre: '3 segundos' },
  { opcion: 4000, nombre: '4 segundos' },
  { opcion: 5000, nombre: '5 segundos' },
  { opcion: 6000, nombre: '6 segundos' },
  { opcion: 7000, nombre: '7 segundos' },
  { opcion: 8000, nombre: '8 segundos' },
  { opcion: 9000, nombre: '9 segundos' },
  { opcion: 10000, nombre: '10 segundos' },
  { opcion: 11000, nombre: '1 segundo' },
  { opcion: 12000, nombre: '2 segundos' },
  { opcion: 13000, nombre: '3 segundos' },
  { opcion: 14000, nombre: '4 segundos' },
  { opcion: 15000, nombre: '5 segundos' },
  { opcion: 16000, nombre: '6 segundos' },
  { opcion: 17000, nombre: '7 segundos' },
  { opcion: 18000, nombre: '8 segundos' },
  { opcion: 19000, nombre: '9 segundos' },
  { opcion: 20000, nombre: '10 segundos' },
];

export const logosIniciales = [
  { opcion: 0, nombre: 'CGO' }
];

export const dominios = [
  { opcion: 'plataform.onsurvey.global', nombre: '' },
  { opcion: 'izzi.culturalgo.com', nombre: '' },
  { opcion: 'gptw.culturalgo.com', nombre: '' },
  { opcion: 'gcti.culturalgo.com', nombre: '' },
  { opcion: 'gcti.onsurvey.global', nombre: '' },
  { opcion: 'itbm.culturalgo.com', nombre: '' },
  { opcion: 'itbm.onsurvey.com', nombre: '' },
];
